import { createContext } from 'react'

export const ShopAndRuntimeConfigContext = createContext({
  publicConfig: {},
  pageProperties: {},
})

// eslint-disable-next-line react/display-name
export const withShopAndRuntimeConfigContextDecorator = configs => story =>
  (
    <ShopAndRuntimeConfigContext.Provider value={configs}>
      {story()}
    </ShopAndRuntimeConfigContext.Provider>
  )
